import { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Pagination,
  Row,
  Spin,
} from "antd";
import { FaFilter } from "react-icons/fa";
import OrderService from "../../../Services/OrderService";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import moment from "moment";
import PatientQueue from "../VCPage/PatientQueue";
import Draggable from "react-draggable";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { IoIosCloseCircle } from "react-icons/io";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import NoDataFound from "../../../Assets/Icons/NoDataCard2.svg";

function OrderReport() {
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [OrderList, setOrderList] = useState([]);
  const [pageNum, setPageNum] = useState("0");
  const [pageCount, setPageCount] = useState();
  const [loading, setLoading] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [apiPayload, setApiPayload] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const firstDate = new Date(year, month, 1);
  const lastDate = new Date(year, month + 1, 0);

  const getOrderList = async () => {
    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));
    setLoading(true);

    const formattedFromDate = formatDate(firstDate);
    const formattedToDate = formatDate(lastDate);

    const payload = {
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      status: 1,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      pageNumber: "0",
    };


    try {
      let result = await OrderService.GetOrderList(payload);
      setOrderList(result.data);
      setApiPayload(payload);

      const payload2 = {
        userId: loginResultObject.user.userId,
        clinic_id: loginResultObject.user.clinic_Id,
        status: 1,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
      };

      const res = await OrderService.GetOrderListCount(payload2);
      setPageCount(res.data.TOTAL_COUNT_STATUS);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrderList();
  }, []);

  const handlePageChange = async (pageNumber) => {
    apiPayload.pageNumber = `${pageNumber - 1}`;

    try {
      let result = await OrderService.GetOrderList(apiPayload);
      setOrderList(result.data);
    } catch (error) {
      console.error(error);
    }
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useForm();
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    transactionId: "",
  });

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleOrderFilter = () => {
    const { patientId, patientName, serviceTransId } = formData;

    if (!patientId && !patientName && !serviceTransId) {
      message.error("Enter Any Details to filter");
      return;
    }

    const payload = {
      ...formData,
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      status: 1,
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
      pageNumber: "0",
    };
    try {
      let result = OrderService.GetOrderList(payload);
      setOrderList(result.data);
    } catch (error) {
      console.error(error);
    }
    payload.pageNumber = null;
    OrderService.GetOrderListCount(payload)
      .then((res) => {
        setPageCount(res.data.TOTAL_COUNT_STATUS);
        handleCancel();
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
    setApiPayload(payload);
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;

    setFromDate(fromDate);
    setToDate(toDate);

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      fromDate: fromDate,
      toDate: toDate,
      statuses: "1,4",
      pageNumber: 0,
    };

    OrderService.GetOrderList(payload)
      .then((res) => {
        setOrderList(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
    payload.pageNumber = null;
    OrderService.GetOrderListCount(payload)
      .then((res) => {
        setPageCount(res.data.TOTAL_COUNT_STATUS);
        handleCancel();
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
    setApiPayload(payload);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <Layouts>
      <Modal
        title="Filter"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
      >
        <Form
          className="formDesign"
          name="trigger"
          layout="vertical"
          form={form}
        >
          <Row gutter={20} className="mt-2 pl-3">
            <div className="flex">
              <Col span={12}>
                <div className="relative  w-full">
                  <input
                    type="text"
                    id="patientname"
                    placeholder=""
                    name="patientName"
                    value={formData.patientName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0  "
                  />
                  <label
                    htmlFor="patientname"
                    className="absolute left-3 -top-3  text-[#189FAA] bg-white px-1 transition-all 
              peer-placeholder-shown:top-1   peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
              peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                  >
                    Patient Name
                  </label>
                </div>
              </Col>

              <Col span={12}>
                <div className="relative w-full  ">
                  <input
                    type="text"
                    id="patientId"
                    placeholder=""
                    name="patientId"
                    value={formData.patientId}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                  />
                  <label
                    htmlFor="patientId"
                    className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
              peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
              peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                  >
                    Patient ID
                  </label>
                </div>
              </Col>
            </div>

            <Col span={12}>
              <div className="relative w-full mt-4">
                <input
                  type="text"
                  id="serviceTransId"
                  name="serviceTransId"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  placeholder=""
                  value={formData.serviceTransId}
                  className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                />
                <label
                  htmlFor="serviceTransId"
                  className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
              peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
              peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                >
                  Appointment Id
                </label>
              </div>
            </Col>

            {/* <Col span={12}>
                      <div className="relative w-[202px] h-[32px] mt-4">
            <select
              id="serviceCode"
              name="serviceCode"
              required
              value={formData.serviceCode}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
              className="w-full h-full px-3 border border-[#A0A2A3] rounded-sm text-[14px] font-medium font-sans text-gray-400 focus:outline-none"
            >
              <option value="" disabled hidden>
                Service Type
              </option>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </select>
          </div>
          
                      </Col> */}
          </Row>

          <Form.Item>
            <div className="flex justify-end  border-brand-colorBorder gap-3 pt-2">
              <Button
                className="h-[32px] Btnwhite rounded-sm w-[82px] border-gray-600 border-2"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                className="h-[32px] w-[118px] text-white rounded-sm"
                type="primary"
                onClick={handleOrderFilter}
                htmlType="submit"
              >
                Filter
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {loading ? (
        <div className="flex justify-center items-center mt-40">
          <Spin />
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center">
            <div className="w-[40%] cursor-pointer font-bold">Order Report</div>
            <div className="flex gap-2 ml-4 items-center justify-end">
              <DatePicker
                onChange={handleMonthFilter}
                picker="month"
                format="MMM YYYY"
                defaultValue={dayjs()}
              />
              <button
                onClick={() => {
                  setIsModalOpen(true);
                }}
                className="text-white font-semibold p-2 rounded-md flex items-center "
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            </div>
          </div>
          <div className="mt-10 mb-10  rounded-lg h-full">
            <div className="p-1">
              {/* <Table
            className="p-0"
            columns={columns}
            dataSource={OrderList}
            pagination={false}
            scroll={{ x: "max-content" }}
          /> */}
              <div className="w-full overflow-x-auton overflow-y-hidden">
                {OrderList && OrderList.length > 0 ? (
                  <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
                    <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                      <tr className="font-sans font-normal">
                        <th className="p-3 whitespace-nowrap">Patient Name</th>
                        <th className="p-3 whitespace-nowrap">Patient ID</th>
                        <th className="p-3 whitespace-nowrap">
                          Appointment ID
                        </th>
                        <th className="p-3 whitespace-nowrap">
                          Transaction ID
                        </th>
                        <th className="p-3 whitespace-nowrap">Paid Date</th>
                        <th className="p-3 whitespace-nowrap">
                          Type of Service
                        </th>
                        <th className="p-3 whitespace-nowrap">
                          Mode of Payment
                        </th>
                        <th className="p-3 whitespace-nowrap">
                          Discount Amount
                        </th>
                        <th className="p-3 whitespace-nowrap">
                          Consultation Amount
                        </th>
                        <th className="p-3 whitespace-nowrap">
                          Medicine Amount
                        </th>
                        <th className="p-3 whitespace-nowrap">Pharmacy Name</th>
                        <th className="p-3 whitespace-nowrap">Lab Amount</th>
                        <th className="p-3 whitespace-nowrap">Lab Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {OrderList.map((order, index) => (
                        <tr
                          key={index}
                          className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                        >
                          <td className="p-3 whitespace-nowrap ">
                            {order.patientName}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.patientId}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.serviceTransId}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.transactionId}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.paymentDate}
                          </td>
                          <td className="p-3 whitespace-nowrap ">Video</td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.paymode}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.discountAmount}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.amount}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.drugAmount}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.pharmacyName}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.labAmount}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {order.labName}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="flex flex-col justify-center items-center">
                    <img
                      src={NoDataFound}
                      alt="No Data"
                      className="h-[20rem]"
                    />
                    <div className="text-xl font-bold">No Order Reports Data</div>
                  </div>
                )}
              </div>
              <div className="flex  justify-end items-end my-4">
                <Pagination
                  defaultCurrent={1}
                  total={pageCount}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                />
              </div>
            </div>
          </div>
        </>
      )}

      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className="cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={handleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}

      {isDrawerOpen && (
        <div className="grid justify-end mt-5">
          {isDrawerOpen && <PatientQueue onClose={onClose} />}
        </div>
      )}
    </Layouts>
  );
}

export default OrderReport;
